import type {} from '@angular/localize/init';
import { appRoutesI18nCache } from '../i18n-cache';

export function liveCasinoRouteI18n(): string {
  return (appRoutesI18nCache['live-casino'] ??= $localize`:url-segment@@live-casino-url-segment:live-casino`);
}
